import {AfterViewInit, ChangeDetectionStrategy, Component, Input, OnDestroy} from '@angular/core';
import {LeafletMarkerClusterModule} from '@bluehalo/ngx-leaflet-markercluster';
import {Map as LeafletMap, map as leafletMap, marker, tileLayer} from 'leaflet';
import {v4 as uuidv4} from 'uuid';
import {TranslatePipe} from '@brunata-angular/util';
import {NumberPipe} from '@brunata-angular/ui';

@Component({
    selector: 'app-meter-map',
    templateUrl: './meter-map.component.html',
    styleUrl: './meter-map.component.scss',
    imports: [LeafletMarkerClusterModule, TranslatePipe, NumberPipe],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MeterMapComponent implements OnDestroy, AfterViewInit {
    @Input({required: true}) longitude!: number;
    @Input({required: true}) latitude!: number;
    readonly mapId = uuidv4();
    private map: LeafletMap | undefined;

    ngAfterViewInit(): void {
        this.map = leafletMap(this.mapId, {
            center: [this.latitude ?? 55, this.longitude ?? 11],
            zoom: 14,
            markerZoomAnimation: true,
        });
        this.map.attributionControl.setPrefix('');
        tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            minZoom: 3,
            attribution:
                '<a href="https://leafletjs.com/" target="_blank">Leaflet</a> | <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
        }).addTo(this.map);
        marker([this.latitude, this.longitude]).addTo(this.map);
        this.map.invalidateSize();
    }

    ngOnDestroy(): void {
        // Remove map to avoid issue "Map container is already initialized", when changing page
        this.map?.remove();
    }
}
